import styles from './IconButton.module.scss';
import Icon, { IconProps } from '../Icon/Icon';
import { ButtonHTMLAttributes } from 'react';

type Props = {
  disabled?: boolean;
  action: () => void;
  icon: IconProps['name'];
  size?: number;
  variant?: 'default' | 'outlined' | 'filled';
} & ButtonHTMLAttributes<HTMLButtonElement>;

const IconButton = ({
  action,
  disabled = false,
  icon,
  size = 20,
  variant = 'default',
  ...otherProps
}: Props) => {
  const buttonClasses = `${styles.button} ${styles[variant]} ${styles[size]} ${
    disabled ? styles.disabled : ''
  }`;

  return (
    <button className={buttonClasses} disabled={disabled} onClick={action} {...otherProps}>
      <div className={`${styles['icon-container']}`}>
        <Icon name={icon} size={size} />
      </div>
    </button>
  );
};

export default IconButton;
